import { Color } from '../../../constants'

export function computeDotBarLayout({
  width,
  height,
  nCircles,
  isCenteredX = false,
  isCenteredY = true,
}: {
  width: number
  height: number
  nCircles: number
  isCenteredX?: boolean
  isCenteredY?: boolean
}) {
  const area = width * height
  const circleArea = area / nCircles
  const diameter0 = Math.sqrt(circleArea)
  const area0 = (width - diameter0) * (height - diameter0)
  let diameter = Math.sqrt(area0 / nCircles)
  let nNodesPerCol = Math.ceil(height / diameter) - 1
  let nNodesPerRow = Math.ceil(width / diameter)
  if (nCircles < 5) {
    diameter = height / 2
    nNodesPerCol = 2
    nNodesPerRow = 2
  }
  let radius = diameter / 2

  // optionally center the circles in x and y
  const centeringYOffset = isCenteredY
    ? (height - nNodesPerCol * diameter) / 2
    : 0
  const maxX =
    (Math.floor(nCircles / nNodesPerCol) % nNodesPerRow) * diameter + radius
  const centeringXOffset = isCenteredX ? (width - maxX) / 2 : 0

  return Array.from({ length: nCircles }, (_, index) => {
    const x =
      (Math.floor(index / nNodesPerCol) % nNodesPerRow) * diameter +
      radius +
      centeringXOffset
    const y = (index % nNodesPerCol) * diameter + radius + centeringYOffset
    return {
      x,
      y,
      r: radius,
    }
  })
}

export function orgOrInitiativeColor({
  initCommTask,
}: {
  initCommTask: boolean
}) {
  return initCommTask ? Color.Yellow : Color.Green
}
